import { LuBrainCircuit } from 'react-icons/lu'
import { copyAndOpenUrl } from '../utilities/general'
import { CHATGPT_URL, CLAUDE_CHAT_URL } from '../constants'
import NodeData from './NodeData'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'

type NodeLLMLinksProps = {
  nodeAddress: string
}

export default function NodeLLMLinks({ nodeAddress }: NodeLLMLinksProps) {
  return (
    <Box>
      <Typography variant="h6">Copy address and open</Typography>
      <NodeData
        icon={<LuBrainCircuit />}
        justifyIcon="center"
        data={[
          [
            <Stack key="llm-links" direction="row" component="span" sx={{
              gap: 1
            }}>
              <Button
                variant="contained"
                onClick={() => copyAndOpenUrl(nodeAddress, CLAUDE_CHAT_URL)}
                startIcon={<img src="/claude-white.svg" width={18} height={18} />}
              >
                Claude
              </Button>
              <Button
                variant="contained"
                onClick={() => copyAndOpenUrl(nodeAddress, CHATGPT_URL)}
                startIcon={<img src="/openai-white.svg" width={18} height={18} />}
              >
                ChatGPT
              </Button>
            </Stack>,
          ],
        ]}
      />
    </Box>
  )
}
